import Page from '../../layout/Page.ianua';

function MyTeachers() {
  return <Page />;
}

export default MyTeachers;
